export default __webpack_public_path__ + "static/media/logo_circle.5fe69fc4.svg";